import { PublishedEventParticipants } from '../@types';
import { extractNumericValue } from './marketViewHelpers';

export type ResultType = '1' | 'X' | '2';
export const RESULT_TYPES: ResultType[] = ['1', 'X', '2'];

export const getResultType = (
  outcomeName: string,
  participants?: PublishedEventParticipants,
  eventName?: string
): ResultType | null => {
  const lower = outcomeName.toLowerCase();

  let homeName = participants?.home.name.toLowerCase();
  let awayName = participants?.away.name.toLowerCase();

  if ((!homeName || !awayName) && eventName) {
    let parts = eventName.toLowerCase().split(' vs ');
    if (parts.length !== 2) {
      parts = eventName.toLowerCase().split(' v ');
    }

    if (parts.length === 2) {
      homeName = parts[0].trim();
      awayName = parts[1].trim();
    }
  }

  if (homeName && lower.startsWith(homeName)) return '1';
  if (awayName && lower.startsWith(awayName)) return '2';

  if (lower.startsWith('draw')) return 'X';

  return null;
};

export const formatMatchResultTotalsOutcomeDisplay = (resultType: ResultType, line: number, isOver: boolean) => {
  const goals = Math.floor(line);
  return isOver ? `${resultType}&${goals + 1}+` : `${resultType}&0-${goals}`;
};

export const parseMatchResultTotalsOutcome = (
  outcomeName: string,
  marketName: string,
  participants?: PublishedEventParticipants,
  eventName?: string
) => {
  const line = extractNumericValue(marketName);
  if (line === null) return null;

  const lower = outcomeName.toLowerCase();
  const isOver = /\s+and\s+over\b/.test(lower) ? true : /\s+and\s+under\b/.test(lower) ? false : null;
  const resultType = getResultType(outcomeName, participants, eventName);

  if (isOver !== null && resultType) {
    return { line, isOver, resultType };
  }

  return null;
};

export const getMatchResultTotalsOutcomeName = (
  outcomeName: string,
  marketName: string,
  participants?: PublishedEventParticipants,
  eventName?: string
): string | null => {
  const parsed = parseMatchResultTotalsOutcome(outcomeName, marketName, participants, eventName);

  if (parsed) {
    return formatMatchResultTotalsOutcomeDisplay(parsed.resultType, parsed.line, parsed.isOver);
  }

  return null;
};
